import { TabsInterfaceNew } from '@prometheus/types';
import i18n from 'i18next';

export const tabs = (): TabsInterfaceNew[] => [
  {
    title: i18n.t('modules.administration.databases.tabs.connection'),
    value: '',
    end: true,
  },
  {
    title: i18n.t('modules.administration.databases.tabs.configuration'),
    value: 'omop-cdm-config',
  },
];
